// extracted by mini-css-extract-plugin
module.exports = {"plainVerseWordContainer":"PlainVerseTextWord_plainVerseWordContainer__2pyxx","plainVerseWbwText":"PlainVerseTextWord_plainVerseWbwText__DTrKx"};